import fetch from '../utils/fetch'
//查询小程序配置
export const fetchSmallProgramSet = (params) =>
  fetch(`/web/try/min/config`, {
    method: 'get',
    params,
  })

export const fetchSetSmallProgram = (data) =>
  fetch(`/web/try/min/config`, {
    method: 'put',
    data,
  })

//配置小程序首页图标
export const fetchSetIcon = (data) =>
  fetch(`/web/try/min/homeIcon`, {
    method: 'put',
    data,
  })

//查询图标
export const fetchIcon = () => fetch(`/web/try/min/homeIcon`)
